import { Divider as MUIDivider, DividerProps } from '@mui/material';

export { type DividerProps } from '@mui/material';

export function Divider(props: DividerProps) {
  return <MUIDivider {...props} />;
}
